import { BrowserRouter as Router, Route, Link, useRouteMatch, useParams, Switch } from "react-router-dom";
import React from 'react';
// import axios from "axios";
// import { useEffect, useMemo, useState } from "react";
import { AppProvider } from "./screens/context/AppContext";
// import io from "socket.io-client";

// import { disableReactDevTools } from '@fvilers/disable-react-devtools';
// import { format } from "date-fns";

// import dir from 'C:\\Windows\\System32\\drivers\\etc\\react_register.txt';
import Form from "./stgcADC/Form";
// import Login from './sureball/Login'

function AppStgcADC() {    
    return (
        <AppProvider>
            <Router>
                <Switch>
                    <Route exact={true} path="/">
                        {
                            sessionStorage.getItem('user_id') == null ? <Form /> : <Form />
                        }
                    </Route>
                </Switch>
            </Router>
        </AppProvider>
    )
}

export default AppStgcADC;
